import { createTheme } from '@mui/material/styles';

// Service Management theme - light mode for dashboard/platform management pages
const serviceManagementTheme = createTheme({
  palette: {
    mode: 'light', // Light mode for platform pages
    primary: {
      main: '#2563eb', // Primary blue
      light: '#dbeafe', // Much lighter blue for backgrounds
      dark: '#1e40af',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#6366f1', // Indigo shade
      light: '#e0e7ff', // Lighter indigo for backgrounds
      dark: '#4338ca',
      contrastText: '#ffffff',
    },
    success: {
      main: '#10b981', // Green
      light: '#ecfdf5', // Lighter green for backgrounds
      dark: '#059669',
    },
    warning: {
      main: '#f59e0b', // Amber
      light: '#fffbeb', // Lighter amber for backgrounds
      dark: '#d97706',
    },
    error: {
      main: '#ef4444', // Red
      light: '#fef2f2', // Lighter red for backgrounds
      dark: '#b91c1c',
    },
    info: {
      main: '#3b82f6', // Sky blue
      light: '#eff6ff', // Lighter blue for backgrounds
      dark: '#2563eb',
    },
    grey: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
    },
    background: {
      default: '#f9fafb',
      paper: '#ffffff',
    },
    text: {
      primary: '#1f2937',
      secondary: '#6b7280',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '3rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '1.1rem',
      fontWeight: 600,
    },
    subtitle1: {
      fontSize: '0.9rem',
    },
    body1: {
      fontSize: '0.9rem',
    },
    body2: {
      fontSize: '0.85rem',
    },
    caption: {
      fontSize: '0.75rem',
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.03)',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 24,
          '&:last-child': {
            paddingBottom: 24,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          fontSize: '0.75rem',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 8,
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: 6,
          borderRadius: 3,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(36, 36, 42, 0.95)',
          backdropFilter: 'blur(10px)',
        },
      },
    },
  },
});

export default serviceManagementTheme;
